// #region Imports
//Components
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-api-call',
    props: {
        mode: {
            type: String,
            required: false,
            default: 'api',
            validValues: ['api', 'views', 'sts'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['api', 'views', 'sts'].includes(value);
            }
        },
        path: {
            type: String,
            required: false,
            default: '',
        },
        successAction: {
            type: Object,
            required: false,
            default: {}
        },
    },
    methods: {
        OnClick(event) {
            // #region Prefent
            event?.preventDefault();
            // #endregion
            // #region Check
            if (utils.isNullOrEmpty(this.path)) {
                return;
            }
            // #endregion                
            // #region Run
            var tApi = appHost.api;
            {
                if (this.mode === "views") {
                    tApi = appHost.views;
                }
                else if (this.mode === "sts") {
                    tApi = appHost.sts;
                }
            }
            tApi.get(this.path)
                .then(e => {
                // #region Sucess
                if (utils.isNullOrEmpty(this.successAction)) {
                    return;
                }
                if (this.successAction.mode === "to") {
                    this.$router.push({ path: this.successAction.path });
                }
                else if (this.successAction.mode === "message") {
                    appHost.notification.showToast(this.successAction.message, "success");
                }
                else if (this.successAction.mode === "refresh") {
                    this.$appHost.eventBus.emit('refresh');
                }
                // #endregion
            })
                .catch(e => {
                this.$appHost.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
            // #endregion
        }
    }
});
// #endregion
